<template>
  <div class="box">
    <div class="top">
      <div class="title"> 批量录入人员（针对2）</div>
    </div>

    <div style="display: flex;justify-content: flex-end;margin: 50px;">
      <el-button type="primary" @click="setMod()">下载导入模板</el-button>
    </div>
    <div class="innerBox">
      <div class="importBox">
        <div class="iptBox">
          <input id="zipIpt" type="file" accept=".zip" @change="handleZipUpload">
          <div class="fakeBox">
            {{  zipImgList.length?  zipName : '点击上传图片压缩包'  }}
            <div v-if="bigImgList.length">
              图片过大: <span v-for="(item,index) in bigImgList" :key="index">{{ item.name }}</span>
            </div>
          </div>
          <div class="clear" @click="clearData('zip')">x</div>
        </div>
        <div class="iptBox">
          <input id="excelIpt"  type="file" accept=".xlsx,.xls" @change="handleXlsx">
          <div class="fakeBox">
            {{  excelTextList.length?  excelName : 'excle表'  }}
          </div>
          <div class="clear" @click="clearData('excel')">x</div>
        </div>

      </div>

      <div class="btn">
        <el-button type="primary" @click="submitForm()">上传数据</el-button>
      </div>

      <div v-if="noImgManList.length">
        缺少信息或图片的人员名单: 
        <div v-for="(item,index) in noImgManList" :key="index">
          {{ item.姓名 }}
        </div>
      </div>
      <div v-if="errorList.length">
        导入失败名单: 
        <div v-for="(item,index) in errorList" :key="index">
          {{ item }}
        </div>
      </div>
      
    </div>

  </div>
</template>

<script>
import { submit2 } from '@/api/index2.js'
import JSZip from 'jszip'
import xlsx from 'xlsx'
export default {
  components: {},
  props: {},
  data() {
    return {
      form: {
        name: '',
        sex: '',
        number: '',
        idNumber: '',
        pictureNumber: '',
        imgType: '',
        dataTime: '',
        file: '',
        category: '',
      },
      zipName: '',
      zipImgList:[],
      excelName: '',
      excelTextList:[],
      allList: [],
      loading: null,
      errorList:[],

      bigImgList:[],
      noImgManList: [],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {

  },
  methods: {
    setMod() {
      import('@/utils/export2Excel').then(excel => {
        // 导出的excel表头名信息
          const tHeader = [
            '姓名',
            '性别',
            '类别',
            '编号',
            '证件号码',
            '照片编号',
            '徽章编号',
            '时间',
          ]
          const filterVal = [
              'name',
              'sex',
              'category',
              'number',
              'idNumber',
              'pictureNumber',
              'imgType',
              'dataTime',
          ]
          const list = [
            {
              name: '小红', sex: '女', category: '食品', number: '1',
              idNumber: '130***********6666',pictureNumber:'6666',imgType: 1,
              dataTime: '时间2026-08-06，(这里要注意,时间前面要加上时间两个字，然后日期用-隔开)'
            },
          ]
          const data = this.formatJson(filterVal, list)
          excel.export_json_to_excel({
              //表头
              header: tHeader,
              //数据
              data,
              //名称
              filename: '批量录入(2)excel导入模板',
              //宽度自适应
              autoWidth: true,
          })
      })
    },
    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    },
    clearData(type) {
      if (type == 'zip') {
        this.zipImgList = []
        this.bigImgList = []
        this.zipName =  '',
        document.getElementById('zipIpt').value = ''
      } else {
        this.excelTextList = []
        this.excelName =  '',
        document.getElementById('excelIpt').value = ''
      }
    },
    handleXlsx(e) {
      const files = e.target.files
      console.log(files)
      this.excelName = files[0].name
      if (!files.length) {
        return
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return alert('上传格式不正确，请上传xls或者xlsx格式')
      }
      const fileReader = new FileReader()
      fileReader.onload = ev => {
        try {
          const data = ev.target.result
          const XLSX = xlsx
          const workbook = XLSX.read(data, {
            type: 'binary',
          })
          const wsname = workbook.SheetNames[0] //取第一张表，wb.SheetNames[0]是获取Sheets中第一个Sheet的名字
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) //生成json表格内容，wb.Sheets[Sheet名]获取第一个Sheet的数据
          const excellist = [] //清空接收数据
          //编辑数据
          for (var i = 0; i < ws.length; i++) {
            excellist.push(ws[i])
          }
          console.log('读取结果', excellist) // 此时得到的是一个内容是对象的数组需要处理
          this.excelTextList = excellist
          // this.$message({
          //   message: '数据导入成功！',
          //   type: 'success',
          // })
        } catch (e) {
          return alert('读取失败!')
        }
      }
      fileReader.readAsBinaryString(files[0])
      // var input = document.getElementById('upload_excel2')
      // input.value = ''
    },

    async handleZipUpload(e) {
      this.bigImgList = []
      const zipFile = e.target.files[0]
      this.zipName = zipFile.name
      const zip = new JSZip()
      const content = await zip.loadAsync(zipFile)
      
      const imageFiles = Object.keys(content.files)
        .filter(name => !content.files[name].dir)
        .filter(name => /\.(jpg|png|gif)$/i.test(name))
      
      const images = await Promise.all(
        imageFiles.map(async name => {
          const zipEntry = content.files[name]
          const arrayBuffer = await zipEntry.async('arraybuffer')
          const blob = new Blob([arrayBuffer], { 
            type: this.getMimeType(name) 
          })
          
          // 获取不带扩展名的文件名
          const fileName = this.removeFileExtension(name.split('/').pop())
          
          const file = new File([blob], fileName, {
            type: blob.type,
            lastModified: Date.now()
          })
          
          return {
            name: fileName,
            size: file.size,
            type: file.type,
            fileObject: file,
            previewUrl: URL.createObjectURL(file)
          }
        })
      )
      
      this.zipImgList = images
      let bigItem = []
      this.zipImgList.forEach(item=> {
        if(item.size / 1024 > 2048) {
          bigItem.push(item)
          this.$notify({
            title: '警告',
            message: `${item.name}图片过大`,
            type: 'warning'
          });
        }
      })
      this.bigImgList = bigItem
      console.log('转换后的File对象:', this.zipImgList)
    },
    getMimeType(filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const types = {
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif'
      }
      return types[extension] || 'application/octet-stream'
    },
    removeFileExtension(filename) {
      return filename.replace(/\.[^/.]+$/, "")
    },

    submitForm() {
      if (!this.zipImgList.length || !this.excelTextList.length) {
        this.$notify({
          title: '警告',
          message: `请上传对应数据`,
          type: 'warning'
        });
        return
      }
      if (this.bigImgList.length) {
        this.$notify({
          title: '警告',
          message: `请修改大小过大的图片，不超过2mb`,
          type: 'warning'
        });
        return
      }

      this.noImgManList = []
      this.errorList = []
      this.loading = this.$loading({
        lock: true,
        text: '加载中，请勿做其他操作',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let allList = this.mergeArrays(this.excelTextList,this.zipImgList)
      console.log('allList',allList)

      let flag = true
      let noImgManList = []
      allList.forEach(item => {
        item.时间 = item.时间.replace("时间", "");
        if (!item.姓名 || !item.徽章编号 || !item.性别 || !item.时间 || !item.照片编号 || !item.类别 || !item.编号 || !item.证件号码 || !item.fileObject) {
          this.$notify({
            title: '警告',
            message: `请核对${item.姓名}`,
            type: 'warning'
          });
          noImgManList.push(item)
          flag = false
        }
      })
      this.noImgManList = noImgManList
      if (!flag) {
        this.loading.close();
        return
      }
      console.log('通过')
      console.log('allList2',allList)
      this.allList = allList
      console.log('this.allList ',this.allList )
      this.putData()


    },
    async putData() {
      for (const item of this.allList) {
        let formData = new FormData()
        formData.append('name', item.姓名)
        formData.append('sex', item.性别 )
        formData.append('number', item.编号 )
        formData.append('idNumber', item.证件号码 )
        formData.append('pictureNumber', item.照片编号 )
        formData.append('imgType', item.徽章编号 )
        formData.append('dataTime', item.时间 )
        formData.append('file', item.fileObject)
        formData.append('category', item.类别)
        try {
          const res = await submit2(formData);
          console.log('sub', res);
          this.$notify({
            title: '提交成功',
            message: item.姓名,
            type: 'success'
          });
          // 添加300毫秒延迟
          await new Promise(resolve => setTimeout(resolve, 500));

        } catch (error) {
          console.error('提交失败:', error);
          this.$notify({
            title: '提交失败',
            message: item.姓名,
            type: 'error'
          });
          this.errorList.push(item.姓名)
        }
      }
      this.loading.close();

    },


    mergeArrays(arrayA, arrayB) {
      // 创建映射表提高查找效率
      const mapB = new Map();
      arrayB.forEach(item => mapB.set(item.name, item));

      // 合并数组
      return arrayA.map(itemA => {
        const matchedItemB = mapB.get(itemA.姓名);
        return matchedItemB ? { ...itemA, ...matchedItemB } : itemA;
      });
    },
    upload(el) {
      console.log('upload')
      if (!el.target.files[0].size) return
      let imgFile = el.target.files[0]
      console.log('imgFile', imgFile)
      // _this.imgL.push({ obj })
      // _this.imgList.push({ file })
      this.form.file = imgFile
      this.picUrl = URL.createObjectURL(imgFile)
    },
    deleteImg() {
      this.picUrl = ''
      this.form.file = ''
    },
  }
}
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.box {
  min-height: 90vh;
  width: 98%;
  margin: 1%;
  padding: 1% 2%;
  background-color: #fff;
}
.innerBox {
  margin:  60px auto 0;
  width: 80%;
}
.importBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.iptBox {
  position: relative;
  width: 300px;
  height: 300px;
  border: #189F92 1px dashed;
  border-radius: 10px;
  // margin-left: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  input {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .clear {
    position: absolute;
    top: 10px;
    right: 20px;
    z-index: 999;
    font-size: 20px;
    color: #333;

  }
}















.el-button--primary {
    color: #FFF;
    background-color: #189F92;
    border-color: #189F92;
}
// margin-top: 100px;
.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60%;
  .title {
    padding-left: 10px;
    border-left: 4px solid #189F92;
  }
  .addBtn {
    padding: 5px 20px;
    border: 1px solid #189F92;
    border-radius: 5px;
    color: #189F92;
    cursor: pointer;
  }
}
.btn {
  width: fit-content;
  margin: 50px auto;
  padding: 7px 50px;
  background-color: #189F92;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
}
.selectBox {
  width: 100%;
  padding: 20px 100px;
}
.select {
  width: 100%;
  display: flex;
  align-items: center;
  margin: 10px 0;
}
.selectText {
  display: flex;
  align-items: center;
  margin-right: 100px;
}
.img {
  width: 100px;
  height: 100px;
}
.upload {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 9;
  cursor: pointer;
}
.delete {
  color: red;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 120%;
  transform: translate(-50%,-50%);
  cursor: pointer;
}
</style>
